<template>
  <div id="occurrence-pizza-chart">
    <apexchart :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: { apexchart: VueApexCharts },
  data: () => ({ }),
  props: ['occurrences', 'target', 'filename'],
  computed: {
    data() {
      if(!this.occurrences || this.occurrences.length == 0 || !this.target || this.target.length == 0) {
        return []
      }
      
      // Se for motivo, precisamos tratar o array de motivos
      if(this.target.useReasonArray) {
        const allReasons = this.occurrences.flatMap(o => o.reasonArray);
        const reduced = allReasons.reduce((acc, reason) => {
          const found = acc?.find(o => o.name === reason);
          
          if(found) { found.data += 1; } 
          else { acc.push({ name: reason, data: 1 }) }
          
          return acc;
        }, []);

        return reduced.sort((a, b) => b.data - a.data); // Ordena por quantidade decrescente
      }

      // Comportamento padrão para outros campos
      const reduced = this.occurrences
        .map(o => ({ name: o[this.target.name] }))
        .reduce((acc, item) => {
          const found = acc?.find(o => o.name === item.name);
          
          if(found) { found.data += 1; } 
          else { acc.push({ name: item.name, data: 1 }) }
          
          return acc;
        }, [])

      return reduced
    },
    series() {
      return this.data.map(x => x.data)
    },
    chartOptions() {
      const self = this;
      return {
        colors:['#00909F', '#FF751B', '#4C999A', '#FF8E3C', '#7BA687', '#89FFDB'],
        chart: {
          type: 'pie',
          toolbar: {
            show: true,
            tools: {
              download: true
            },
            export: {
              csv: { filename: self.filename },
              png: { filename: self.filename },
              svg: { filename: self.filename },
            }
          },
        },
        labels: this.data.map(x => x.name),
        stroke: {
          width: 0,
          colors: undefined
        },
        legend: {
          position: 'left'
        },
      }
    },
    label() {
      return this.$t('quantidade')
    },
  }
}
</script>